<template>
  <div class="app-container" :style="cornerImage">
    <v-navigation-drawer
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawers.root"
      fixed
      :temporary="temporary"
      permanent
      app
      class="root-menu menus"
    >
      <v-toolbar flat class="py-3 elevation-5" style="background: white; z-index: 1;" @click="goToHome()">
        <v-spacer></v-spacer>
        <img src="@/assets/logo.png" height="50px" >
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-list class="pa-0 fill-space">
        <v-list-tile
          value="true"
          v-for="(item, i) in items"
          :key="i"
          @click="menuItem(item)"
          class="border-bottom"
          v-bind:class="{ 'menu-selected': selectedMenus.root == item || (!!selectedMenus.currentRoute && selectedMenus.currentRoute == item.route) }"
          >
          <v-list-tile-action>
            <v-badge right color="info" v-model="item.showBadge">
              <span slot="badge" v-if="!!item.showBadge && !!item.badge.number" >{{displayBadge(item.badge.number)}}</span>
              <v-icon v-if="item.icon" v-html="item.icon"></v-icon>
              <div class="svg-icon" v-if="item.svg" v-html="icons[item.svg]"></div>
            </v-badge>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action v-if="item.subMenus && item.subMenus.length">
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-list class="pa-0">
        <v-list-tile class="border-top" @click="goTo('changepassword')">
          <v-list-tile-action class="icon-space">
            <div class="svg-icon" v-html="icons['lock.svg']"></div>
          </v-list-tile-action>
          <v-list-tile-content class="icon-text">
            <v-list-tile-title>{{ $t('message.changePassword') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="border-top" @click="changeLanguage()">
          <v-list-tile-action class="icon-space">
            <v-icon>language</v-icon>
          </v-list-tile-action>
          <v-list-tile-content class="icon-text">
            <v-list-tile-title>{{ $t('message.toggleLanguageText') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile class="border-top" @click="closeSesion()">
          <v-list-tile-action class="icon-space">
            <div class="svg-icon" v-html="icons['icon-cerrar-sesion.svg']"></div>
          </v-list-tile-action>
          <v-list-tile-content class="icon-text">
            <v-list-tile-title>{{ $t('message.closeSession') }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-content v-bind:class="{ 'root-drawer-active': drawers.root, 'second-drawer-active': drawers.second }">
      <router-view :key="routerViewKey"/>
    </v-content>
  </div>
</template>

<style>
.v-badge > span{
  width: 18px;
  height: 18px;
  top: -8px;
  right: -10px;
}
</style>

<style scoped>
.v-toolbar {
  cursor: pointer;
}
.root-menu.menus {
  display: flex;
  flex-direction: column;
  background-image: linear-gradient(to bottom, #0B9DD9, #064F6D);
}
.root-menu.menus .fill-space {
  flex-grow: 1;
  margin-bottom: -1px;
}

.border-bottom {
  border-bottom: solid 1px white;
}
.border-top {
  border-top: solid 1px white;
}

.app-container {
  padding: 50px;
}

.menus{
  color: var(--v-menuText-base);
}

.menus .theme--light.v-list{
  background-color: transparent;
  background: none;
  color: var(--v-menuText-base);
}

.menus >>> .v-list__tile{
  color: var(--v-menuText-base) !important;
  caret-color: var(--v-menuText-base) !important;
  height: 60px;
}

.menus .v-list * {
  color: inherit;
}

.menus .menu-selected >>> .v-list__tile{
  background-color: var(--v-menuSelectedItem-base);
  color: var(--v-menuSelectedText-base) !important;
  caret-color: var(--v-menuSelectedText-base) !important;
}

.menus >>> .v-list__tile:hover{
  background-color: var(--v-menuSelectedItem-base) !important;
  color: var(--v-menuSelectedText-base) !important;
  caret-color: var(--v-menuSelectedText-base) !important;
}

.menus >>> .v-list__group__items{
  background-color: var(--v-menuBackground-darken1);
}

.menus >>> .v-list__group__header__append-icon i{
  color: var(--v-menuText-base)
}

/* SVG icon styles */
.svg-icon, .svg-icon >>> svg {
  height: 24px !important;
}
.menus >>> .v-list__tile path {
  fill: white !important;
}
.menus >>> .v-list__tile:hover path, .menus .menu-selected >>> .v-list__tile path {
  fill: var(--v-menuSelectedText-base) !important;
}

.root-menu:not(.v-navigation-drawer--temporary){
  z-index: 4;
}

.root-drawer-active{
  /* Variable */
  padding-left: 300px !important;
}

.second-drawer-active{
  /* Variable */
  padding-left: 600px !important;
}

</style>

<script>

import { events } from '../main';
import { i18n } from '../utils/locales/default';
import { filterMenuByEnvironment } from '../utils/menuVisibility';

export default {
  name: 'core',
  data () {
    return {
      icons: {},
      cornerImage: {
        'background-image': `url('${require("../assets/esquina.svg")}')`,
        'background-position-x': '100%',
        'min-height': '832px',
      },
      user: {},
      clipped: true,
      drawers: {
        root: true,
        second: false,
      },
      fixed: true,
      temporary: false,
      items: this.filterPaths([
        {
          svg: "icon-usuarios.svg",
          title: 'Usuarios',
          route: 'userlist',
          documentName: 'user',
          level:1
        },
        {
          svg: 'icon-permisos.svg',
          title: 'Matriz de Permisos',
          route: 'rolelist',
          documentName: 'role',
          level:1
        },
        {
          svg: 'icon-proveedores.svg',
          title: 'Catálogo de Proveedores',
          route: 'Supplierslist',
          documentName: 'Suppliers',
          level: 1
        },
        {
          svg: 'icon-complementos-de-pago.svg',
          title: "Complementos de Pago",
          route: "PaymentSupplementslist",
          documentName: "PaymentSupplements",
          level: 1
        },
        {
          svg: "icon-notificaciones.svg",
          title: "Notificaciones",
          route: "Notificationlist",
          documentName: "NotificationConfiguration",
          level: 1
        },
        {
          svg: "icon-lectura-de-correo.svg",
          title: "Documentos",
          route: "Documentslist",
          documentName: "Documents",
          level: 1
        },
      ]),
      miniVariant: false,
      right: false,
      rightDrawer: false,
      title: 'Whirlpool - Portal de Proveedores',
      badgeIntervals: [],
      selectedMenus: {
        root: undefined,
        second: undefined,
        third: undefined,
        currentRoute: undefined
      },
      menusStoreStates: {
        root: false,
        second: false
      },
      routerViewKey: 0,
    }
  },
  methods: {
    snackbar: function(message) {
      events.$emit('snackbar', message);
    },
    checkMenusSelected(){
      this.selectedMenus.currentRoute = this.$route.name;
      this.items.forEach(rootMenuElement => {
        if(rootMenuElement.subMenus){
          rootMenuElement.subMenus.forEach(secondMenuElement => {
            if(secondMenuElement.subMenus){
              secondMenuElement.subMenus.forEach(thirdMenuElement => {
                if(thirdMenuElement.route == this.selectedMenus.currentRoute){
                  //Force Open TODO
                  this.selectedMenus.third = thirdMenuElement;
                  this.selectedMenus.second = secondMenuElement;
                  this.selectedMenus.root = rootMenuElement;
                  secondMenuElement.open = true;
                  this.drawers.second = true;
                  this.drawers.root = true;
                }
              });
            }else{
              if(secondMenuElement.route == this.selectedMenus.currentRoute){
                this.selectedMenus.second = secondMenuElement;
                this.selectedMenus.root = rootMenuElement;
                this.drawers.second = true;
              }
            }
          })
        }else{
          if(rootMenuElement.route == this.selectedMenus.currentRoute){
            this.selectedMenus.root = rootMenuElement;
            this.drawers.root = true;
          }
        }
      })
    },
    openCloseMenu(){
      if(this.drawers.root){
        this.menusStoreStates.root = this.drawers.root;
        this.menusStoreStates.second = this.drawers.second;
        this.drawers.root = false;
        this.drawers.second = false;
      }else{
        this.drawers.second = this.menusStoreStates.second;
        this.drawers.root = true;
      }
    },
    menuItem(item){
      //Set Selected Item
      if(item.level == 1){
        this.selectedMenus.root = item;
        this.selectedMenus.second = undefined;
        this.selectedMenus.third = undefined;
      }else if(item.level == 2){
        this.selectedMenus.second = item;
        if(item.route){
          this.selectedMenus.third = undefined;
        }
      }else if(item.level == 3){
        this.selectedMenus.third = item;
      }

      if(item.subMenus && item.subMenus.length){
        if(item.level == 1){
          this.drawers.second = true;
        }
      }else{
        if(item.level == 1){
          this.drawers.second = false;
        }
        this.goTo(item.route);
      }
    },
    goToHome() {
      this.goTo("");
      this.selectedMenus.root = undefined;
      this.selectedMenus.second = undefined;
      this.selectedMenus.third = undefined;
      this.selectedMenus.currentRoute = undefined;
    },
    getSubMenuItems(item){
      if(!item || !item.subMenus){
        return [];
      }
      return item.subMenus;
    },
    goTo(route) {
      this.selectedMenus.currentRoute = route;
      this.$router.push('/'+route);
      if (this.$router.currentRoute.name == route) {
        this.routerViewKey++;
      }
    },
    closeSesion: function(fullPath) {
      events.$emit('closeSession');
    },
    changeLanguage() {
      const newLocale = i18n.locale === 'en' ? 'es' : 'en';
      this.$set(i18n, 'locale', newLocale);
      
      // Save language preference to backend
      this.$http.put('user/language', { language: newLocale })
        .then(response => {
          // Language preference saved successfully
          if (this.user) {
            this.user.language = newLocale;
          }
          // Mostrar mensaje de éxito
          const message = newLocale === 'es' 
            ? 'Idioma cambiado a Español' 
            : 'Language changed to English';
          this.snackbar(message);
          console.log('Language preference saved successfully:', newLocale);
        })
        .catch(error => {
          console.error('Error saving language preference:', error);
          // Revertir el cambio si falla
          const previousLocale = newLocale === 'en' ? 'es' : 'en';
          this.$set(i18n, 'locale', previousLocale);
          this.snackbar('Error al guardar la preferencia de idioma. Por favor, intente nuevamente.');
        });
    },
    filterPaths: function(paths) {
      const permissions = JSON.parse(localStorage.getItem('userCredentials'));
      if (JSON.stringify(permissions).length <= 2) {
        return [];
      }
      
      const clearedPaths = paths.filter(x => {
        if (x.reportName) {
          return permissions[`${x.reportName}Report`];
        }
        if(!!x.permissionsLike){
          return !!Object.keys(permissions).find(permission => permission.includes(x.permissionsLike));
        }
        if(!!x.permission){
          return permissions[x.permission];
        }
        if(!x.documentName){
          return true;
        }
        return permissions[`${x.documentName}Read`] ||
        permissions[`${x.documentName}Update`] ||
        permissions[`${x.documentName}Create`] ||
        permissions[`${x.documentName}Delete`]
      });
      return filterMenuByEnvironment(clearedPaths);
    },
    displayBadge: function (value){
      if(value > 9){
        return "+9"
      }
      return value;
    },
    // PROD: Gestor de jobs solo para pruebas/preprod — no exponer en producción.
    addPreproductionMenuItems() {
      const alreadyExists = this.items.some(item => item.route === 'JobReportManager');
      if (alreadyExists) {
        return;
      }

      this.items.push({
        icon: 'build',
        title: 'Gestión de Jobs',
        route: 'JobReportManager',
        level: 1
      });
    }
  },
  mounted () {
    var token = localStorage.getItem("userToken");
    if (!token) {
      this.$router.push('/login');
      return;
    }

    let iconPromises = this.items
      .filter(x => x.svg)
      .map(x =>
        this.$http.get(require(`../assets/${x.svg}`))
          .then(result => {
            this.icons[x.svg] = result.body;
          })
      );

    iconPromises.push(
      this.$http.get(require(`../assets/icon-cerrar-sesion.svg`))
        .then(result => {
          this.icons["icon-cerrar-sesion.svg"] = result.body;
        })
      );
    iconPromises.push(
    this.$http.get(require(`../assets/lock.svg`))
      .then(result => {
        this.icons["lock.svg"] = result.body;
      })
    );

    Promise.all(iconPromises).then(() => this.$forceUpdate());

    this.$http.get('app/getMyUser')
      .then(response => {
        this.user = response.body.user;
        // Establecer el idioma del usuario si está disponible
        const userLanguage = (response.body.user && response.body.user.language) || response.body.language || 'es';
        if (userLanguage && (userLanguage === 'es' || userLanguage === 'en')) {
          i18n.locale = userLanguage;
          console.log('Language loaded from user preference:', userLanguage);
        }
      }, error => {
        this.closeSesion();
      });

    // PROD: menú "Gestión de Jobs" deshabilitado (solo pruebas/preprod).
    this.$http.get('app/getEnvironment')
      .then(response => {
        const env = (response.body && response.body.environment) || '';
        const isPreproduction = env === 'preprod' || env === 'pre-prod' || env === 'preproduccion';
        if (isPreproduction) {
          this.addPreproductionMenuItems();
        }
      })
      .catch(error => {
        console.error('Error checking environment in menu:', error);
      });

    this.checkMenusSelected();

    this.items.filter(x => !!x.showBadge).forEach(item => {
      if(!!item.badge.refreshFunction){
        item.badge.refreshFunction(item.badge);
        if(!!item.badge.refreshTime){
          this.badgeIntervals.push(setInterval(item.badge.refreshFunction.bind(this, item.badge), item.badge.refreshTime));
        }
      }
    });

    events.$on('closeSession', () => {
      this.badgeIntervals.forEach(intreval => {
        clearInterval(intreval);
      });
    });
  },
  computed: {
    imageSrc() {
      if(this.user && this.user.imageMIME && this.user.imageData){
        return `data:${this.user.imageMIME};base64,${this.user.imageData}`;
      }else{
        return undefined
      }
    }
  }
}
</script>